import styled from 'styled-components';

const StyledBackground = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: #111314;
	opacity: 0.5;
`;

export { StyledBackground };
